(($) => {
    let $sections;

    window.addEventListener('load', init);

    function init() {
        $sections = $('section.tabbed-important-plan-documents');

        if ($sections.length === 0) {
            return false;
        }

        $sections.each(initModule);
    }

    function initModule(moduleIndex, module) {
        if (!module) {
            return false;
        }

        let $module = $(module);
        let $select = $module.find('select');
        let $navLinks = $module.find('a.nav-link');
        let $panes = $module.find('.tab-pane');

        bind();

        $module.addClass('initialized');

        function bind() {
            $select.on('change', onSelectChange);
            $navLinks.on('click', onNavLinksClick);
        }

        function onSelectChange(event) {
            if (!event instanceof Event) {
                return false;
            }

            let i = $select.val();
            $navLinks.eq(i).trigger('click');
        }

        function onNavLinksClick(event) {
            if (!event instanceof Event) {
                return false;
            }

            let i = $(event.target).attr('data-index');
            $select.val(i);
        }
    }

})(jQuery);
